import { InjectionToken } from '@angular/core';

export type AdvisoryType = 'wq' | 'cso';

export interface AppConfig {
  showAdvisories: AdvisoryType[];
}

export const APP_CONFIG = new InjectionToken<AppConfig>('app.config');
